import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../component/form/Grid';
import Separator from '../../page/workQueue2/extras/Separator';
import TextField from '../../component/form/TextField';
import HtmlEditor from '../../component/form/HtmlEditor';
import { QueryKeys } from '../../util/products';
import Checkbox from '../../component/form/Checkbox';
import Select from '../../component/form/Select';
import { ImageList, ImageListItem } from '../../component/form/ImageList';
import UploadField from '../../component/form/FileUpload';
import Label from '../../component/form/Label';
import { getClient } from '../../apollo';
import gql from 'graphql-tag';
import AutoComplete from '../../component/form/AutoComplete';
import TagButton from '../../component/form/TagButton';
import BiggerMessageBar from '../../component/BiggerMessageBar';
import { niceDateFromString, shortDateTimeFromString } from '../../util/date';
import ColumnLayout from '../../component/ColumnLayout';
import ValidationPlaceholder from '../../component/form/ValidationPlaceholder';

class StockItemView extends Component {
    state = {
        productCategories: []
    };

    componentDidMount() {
        this._isMounted = true;
        const loadCategories = async () => {
            const query = gql`
                query ReadProductCategories {
                    readProductCategories(
                        filter: { ClassName: { in: [_CoreProductCategory, _SilverShopPageProductCategory] } }
                    ) {
                        nodes {
                            ID
                            Title
                            URLSegment
                        }
                    }
                }
            `;
            const { data } = (await getClient().query({ query })) || {};
            return data;
        };
        loadCategories().then(data => {
            if (data && data.readProductCategories) {
                if (this._isMounted) {
                    this.setState({
                        productCategories: data.readProductCategories.nodes.map(({ __typename, ...parts }) => parts)
                    });
                }
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { classes, form } = this.props;
        return (
            <div>
                <Grid container spacing={3}>
                    <div style={{ padding: 9 }} />
                    <ColumnLayout>
                        <Grid container>{this.renderItemDetails()}</Grid>
                        <Grid container>
                            {this.renderItemCategories()}
                            {this.renderItemPhotos()}
                        </Grid>
                    </ColumnLayout>
                    <div style={{ padding: 9 }} />
                    <Grid item xs={12}>
                        <Separator />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {this.renderStockActive()}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <p className={classes.metadata}>
                            <strong>Date Created: </strong>
                            <span className="regular">{niceDateFromString(form.getField('Created'))}</span>
                            <br />
                            <strong>Last Updated: </strong>
                            <span className="regular">{shortDateTimeFromString(form.getField('LastEdited'))}</span>
                        </p>
                    </Grid>
                </Grid>
            </div>
        );
    }

    renderStockActive() {
        const { form } = this.props;
        const isActive = form.getField('AllowPurchase');
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Checkbox form={form} name="AllowPurchase" label="Active (not retired)" />

                    {!isActive && (
                        <BiggerMessageBar messageType="error">
                            Retired items do not appear in searches and cannot be added to new quotes, bills or
                            invoices.
                        </BiggerMessageBar>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderItemDetails() {
        const { form } = this.props;
        const isCoffin =
            QueryKeys.Coffins === form.getField('Parent.URLSegment') ||
            (form.getField('ProductCategories') || []).find(obj => QueryKeys.Coffins === obj.URLSegment);
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Label>Item Details</Label>
                </Grid>
                <Grid item xs={12}>
                    <TextField form={form} name="Title" label="Title" required />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField form={form} name="InternalItemID" label="Item Code/SKU" required />
                </Grid>
                {isCoffin && (
                    <Grid item xs={12} sm={6}>
                        <TextField form={form} name="CoffinTrim" label="Coffin Trim" />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <HtmlEditor form={form} name="Content" label="Description" height={300} />
                </Grid>
            </Grid>
        );
    }

    renderItemCategories() {
        const { form } = this.props;
        const parentID = form.getField('Parent.ID');
        const extraCategories = form.getField('ProductCategories') || [];
        const { productCategories } = this.state;
        const categoryOptions = productCategories
            .map(obj => ({
                label: obj.Title,
                value: obj.ID
            }))
            .sort((a, b) => (a.label < b.label ? -1 : 1));
        const extrasOptions = categoryOptions.filter(obj => {
            if (parentID === obj.value) return false;
            if (!extraCategories.length) return true;
            return !extraCategories.find(cat => {
                return obj.value === cat.ID;
            });
        });
        const onChangeMain = (evt, val) => {
            const wasID = form.getField('Parent.ID');
            if (val > 0 && val !== wasID) {
                const { productCategories } = this.state;
                const Parent = productCategories.find(obj => val === obj.ID);
                if (Parent) {
                    form.setField({ Parent });
                }
            }
        };
        const onChangeExtra = item => {
            if (item && item.value && item.value > 0) {
                const ProductCategories = extraCategories.toSpliced();
                const { productCategories } = this.state;
                const newItem = productCategories.find(obj => obj.ID === item.value);
                if (newItem) {
                    ProductCategories.push(newItem);
                    form.setField({ ProductCategories });
                }
            }
        };
        const onClickRemove = ID => {
            if (ID && ID > 0) {
                const ProductCategories = extraCategories.filter(obj => ID !== obj.ID);
                form.setField({ ProductCategories });
            }
        };
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Label>Item Categorisation</Label>
                </Grid>
                <Grid item xs={12}>
                    <ValidationPlaceholder form={form} name="Parent.ID">
                        <Select
                            required
                            label="Core Category"
                            allowNone={false}
                            options={categoryOptions}
                            value={parentID}
                            onChange={onChangeMain}
                        />
                    </ValidationPlaceholder>
                </Grid>
                <Grid item xs={12}>
                    <AutoComplete
                        placeholder={
                            extraCategories && !!extraCategories.length
                                ? 'Add another category...'
                                : 'Add an extra category...'
                        }
                        label="Additional Categories"
                        options={extrasOptions}
                        clearOnSelect
                        onChange={onChangeExtra}
                    />
                    {!!extraCategories && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                            {extraCategories.map(obj => (
                                <TagButton key={obj.ID} text={obj.Title} onClickRemove={() => onClickRemove(obj.ID)} />
                            ))}
                        </div>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderItemPhotos() {
        const { form } = this.props;
        const ImageID = form.getField('ImageID');
        const ImageURL = form.getField('ImageURL');
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Label>Product Photo</Label>
                </Grid>
                <Grid item xs={12}>
                    {ImageURL && ImageID > 0 && (
                        <div style={{ paddingBottom: '1rem' }}>
                            <ImageList>
                                <ImageListItem
                                    value={{ tileWidth: 2, image: ImageURL }}
                                    onDelete={() => this.onAttachmentRemove()}
                                    onClick={() => window.open(ImageURL)}
                                />
                            </ImageList>
                        </div>
                    )}
                    <UploadField
                        folderPath="/productimages"
                        accept=".png, .jpg, .jpeg, .gif"
                        prompt="Upload Photo"
                        publish
                        onComplete={({ uploadFile }) => this.handleUploadAttachment(uploadFile)}
                    />
                </Grid>
            </Grid>
        );
    }

    handleUploadAttachment(uploadFile) {
        const { form } = this.props;
        form.setField({
            ImageID: uploadFile.ID,
            ImageURL: uploadFile.AbsoluteLink
        });
    }

    onAttachmentRemove() {
        const { form } = this.props;
        form.setField({ ImageID: null, ImageURL: null });
    }
}

const styles = ({ breakpoints }) => ({
    metadata: {
        textAlign: 'end',
        [breakpoints.down('sm')]: {
            textAlign: 'start'
        }
    }
});

export default withStyles(styles)(StockItemView);
